import { Stack, TextField, Typography } from "@mui/material"

export const GenericTextField = ({ label, placeholder, required = true, children, ...others }) => {
  return (
    <Stack gap={0.5} width={'100%'}>
      <Typography fontSize={'14px'}>
        {label}
        {required ? <span style={{ color: 'red' }}> *</span> : ''}
      </Typography>
      <TextField
        {...others}
        variant="standard"
        fullWidth
        placeholder={placeholder}
        size="small"
      >
        {children}
      </TextField>
    </Stack>
  )
}